import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ServiceAreas from "../../services/ServiceAreas";
import lineimg from "../../../../assets/images/line.png";

const testimonials = [
  {
    name: "Angie Bastardo",
    date: "2024-10-23",
    rating: 5,
    review: "This company completed a very challenging extension for us.",
    avatar: "https://i.pravatar.cc/150?u=angie",
    verified: true,
  },
  {
    name: "Sara Medina",
    date: "2024-10-22",
    rating: 5,
    review: "They recently completed a major basement suite addition.",
    avatar: "https://i.pravatar.cc/150?u=sara",
    verified: true,
  },
  {
    name: "Juan Medina",
    date: "2024-10-12",
    rating: 5,
    review:
      "Our kitchen looks and feels brand new to us again. Very professional work, done in a timely manner.",
    avatar: "https://i.pravatar.cc/150?u=juan",
    verified: true,
  },
  {
    name: "José Oliveros",
    date: "2024-10-12",
    rating: 5,
    review:
      "The team is punctual and reliable. I am very confident in hiring them again.",
    avatar: "https://i.pravatar.cc/150?u=jose",
    verified: true,
  },
  {
    name: "Elisabeth Herrera",
    date: "2024-10-10",
    rating: 5,
    review:
      "They completed our kitchen remodel in a timely manner and did quality work.",
    avatar: "https://i.pravatar.cc/150?u=elisabeth",
    verified: true,
  },
  {
    name: "Samuel Miano",
    date: "2024-10-02",
    rating: 5,
    review:
      "They transformed our three bathrooms brilliantly. Their professionalism, reliability.",
    avatar: "https://i.pravatar.cc/150?u=samuel",
    verified: true,
  },
];

const StarRating = ({ rating }) => (
  <div className="text-warning mb-2">
    {"★".repeat(rating)}
    {"☆".repeat(5 - rating)}
  </div>
);

const TestimonialCarousel = () => {
  const testimonialSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const projects = [
    {
      src: "assets/Images/Kitchen/kitch-1.jpg",
      alt: "Kitchen Renovations",
      link: "/kitchen-renovations",
      title: "Kitchen Renovations",
    },
    {
      src: "assets/Images/Bathroom/bath3.jpg",
      alt: "Bathroom Renovations",
      link: "/bathroom-renovation",
      title: "Bathroom Renovations",
    },
    {
      src: "assets/Images/Home/home7.jpg",
      alt: "Home Extensions",
      link: "/home-renovation",
      title: "Home Extensions",
    },
    {
      src: "assets/Images/Basement/bm13.jpg",
      alt: "Basement Renovations",
      link: "/basement-renovation",
      title: "Basement Renovations",
    },
  ];

  const projectSettings = {
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2500,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
      <div
        className="container-fluid py-5 mt-4"
        style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
      >
        <h2 className="text-center fw-bold mb-5" data-sal='slide-up' data-sal-duration='1000' data-sal-delay='300' >What Our Clients Say</h2>
        <Slider {...testimonialSettings}>
          {testimonials.map((testimonial, index) => (
            <div key={index} className="px-3 mb-4"data-sal='slide-down' data-sal-duration='1000' data-sal-delay='300'  >
              <div className="testimonial-card text-center p-4 shadow-sm rounded bg-light d-flex flex-column h-100 ">
                <div className="avatar-container py-4 mb-3 d-flex justify-content-center align-items-center ">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="rounded-pill shadow"
                    style={{
                      width: 80,
                      height: 80,
                      objectFit: "cover",
                      padding: "5px",
                    }}
                  />
                </div>
                <h6 className="fw-semibold mb-1">{testimonial.name}</h6>
                <small className="text-muted">{testimonial.date}</small>
                <div className="my-2">
                  <StarRating rating={testimonial.rating} />
                </div>
                {testimonial.verified && (
                  <div className="text-primary mb-2">
                    <i className="bi bi-patch-check-fill me-1" />
                    Verified
                  </div>
                )}
                <p className="text-muted small mt-auto">{testimonial.review}</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>

      <div className="goldendragonrenovations_panel_design_9 d-none d-md-block">
        <div className="container-fluid">
          <div className="row no-gutters">
            <div className="col-12 mb-3 text-center p-4 " data-sal='slide-right' data-sal-duration='2000' data-sal-delay='300'>
              <h2  
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: "2rem",
                }}
              >
                Our Recent Projects
                <span>
                  <img className="lin_pl ms-2" src={lineimg} alt="line" />
                </span>
              </h2>
            </div>
            <div className="col-12 p-3 d-flex align-items-start p-4">
              <div className="col-lg-3 col-md-4 mb-0 me-lg-4" data-sal='slide-left' data-sal-duration='2000' data-sal-delay='300' >
                <a href="/work-portfolio">
                  <button
                    className="round_teo w-100"
                    style={{
                      fontSize: "1.5rem",
                      padding: "15px",
                      textTransform: "uppercase",
                    }}
                  >
                    Our Recent{" "}
                    <span
                      className="highlight-span fw-bold "
                      style={{ display: "block", fontSize: "1.8rem" }}
                    >
                      Projects &rarr;
                    </span>
                  </button>
                </a>
              </div>
              <div className="col-lg-9 col-md-8" data-sal='slide-up' data-sal-duration='2000' data-sal-delay='300'>
                <Slider {...projectSettings}>
                  {projects.map((item, index) => (
                    <div key={index} className="px-2">
                      <div className="galle_pic-container position-relative">
                        <img
                          src={item.src}
                          alt={item.alt}
                          className="galle_pic img-fluid"
                          style={{
                            width: "100%",
                            height: "377px",
                            objectFit: "cover",
                          }}
                        />
                        <div
                          className="position-absolute"
                          style={{
                            bottom: "20px",
                            left: "20px",
                            background: "white",
                            padding: "12px 16px",
                            textTransform: "uppercase",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                            opacity: "0.8",
                            maxWidth: "80%",
                          }}
                        >
                          <a
                            href={item.link}
                            className="text-dark text-decoration-none"
                          >
                            <strong>{item.title}</strong>{" "}
                            <span className="ms-2">&rarr;</span>
                          </a>
                        </div>
                        <a
                          href={item.link}
                          className="text-dark text-decoration-none"
                        ></a>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ServiceAreas />
    </>
  );
};

export default TestimonialCarousel;
